import React, { useState } from 'react';
import { useAuth } from '../../context/AuthContext';
import BackButton from '../../components/BackButton';
import RateLimitModal from '../../components/RateLimitModal';
import api from '../../services/api';
import './UtilityPage.css';

const Base64Encoder = () => {
  const { isAuthenticated } = useAuth();
  const [input, setInput] = useState('');
  const [output, setOutput] = useState('');
  const [mode, setMode] = useState('encode');
  const [error, setError] = useState('');
  const [showRateLimitModal, setShowRateLimitModal] = useState(false);
  const [rateLimitError, setRateLimitError] = useState(null);

  const handleProcess = async () => {
    if (!input.trim()) {
      setError('Please enter text');
      return;
    }

    try {
      setError('');
      const endpoint = mode === 'encode' ? '/api/utilities/base64/encode' : '/api/utilities/base64/decode';
      const response = await api.post(endpoint, { text: input });
      setOutput(mode === 'encode' ? response.data.encoded : response.data.decoded);
    } catch (err) {
      if (err.response?.status === 429) {
        const errorData = err.response.data;
        setRateLimitError({
          message: errorData.message || 'Rate limit exceeded',
          isAuthenticated: errorData.isAuthenticated !== undefined ? errorData.isAuthenticated : isAuthenticated,
          suggestion: errorData.suggestion || '',
          currentLimit: errorData.currentLimit || '',
          loginLimit: errorData.loginLimit || '',
          premiumLimit: errorData.premiumLimit || ''
        });
        setShowRateLimitModal(true);
      } else {
        setError(err.response?.data?.error || 'Failed to process');
        setOutput('');
      }
    }
  };

  return (
    <div className="utility-page">
      <BackButton />
      <div className="utility-container">
        <h1>Base64 Encoder/Decoder</h1>
        <div className="utility-form">
          <div className="mode-selector">
            <button
              className={mode === 'encode' ? 'btn-mode active' : 'btn-mode'}
              onClick={() => { setMode('encode'); setOutput(''); }}
            >
              Encode
            </button>
            <button
              className={mode === 'decode' ? 'btn-mode active' : 'btn-mode'}
              onClick={() => { setMode('decode'); setOutput(''); }}
            >
              Decode
            </button>
          </div>
          <div className="input-section">
            <label>{mode === 'encode' ? 'Text to Encode' : 'Base64 to Decode'}</label>
            <textarea
              value={input}
              onChange={(e) => setInput(e.target.value)}
              placeholder={mode === 'encode' ? 'Enter text' : 'Enter base64 string'}
              rows={5}
            />
          </div>
          <button onClick={handleProcess} className="btn-process">
            {mode === 'encode' ? 'Encode' : 'Decode'}
          </button>
          {error && <div className="error-message">{error}</div>}
          {output && (
            <div className="output-section">
              <label>Result</label>
              <textarea value={output} readOnly rows={5} />
            </div>
          )}
        </div>
      </div>
      
      {showRateLimitModal && rateLimitError && (
        <RateLimitModal 
          error={rateLimitError}
          onClose={() => {
            setShowRateLimitModal(false);
            setRateLimitError(null);
          }}
        />
      )}
    </div>
  );
};

export default Base64Encoder;

